var map = {
	"./config.dev": 42338,
	"./config.dev.js": 42338,
	"./config.js": 77942,
	"./config.poc1": 61475,
	"./config.poc1.js": 61475,
	"./config.poc2": 47468,
	"./config.poc2.js": 47468,
	"./config.prod": 56645,
	"./config.prod.js": 56645,
	"./config.prodtest": 98733,
	"./config.prodtest.js": 98733,
	"./config.test": 38446,
	"./config.test.js": 38446
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74193;